import React, { useState } from 'react';
import { 
  TextField, 
  Box, 
  InputAdornment, 
  IconButton,
  useTheme,
  styled,
  alpha
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import ClearIcon from '@mui/icons-material/Clear';

const SearchField = styled(TextField)(({ theme }) => ({
  '& .MuiOutlinedInput-root': {
    borderRadius: '24px',
    backgroundColor: alpha(theme.palette.primary.light, 0.1),
    transition: 'all 0.3s ease',
    '& input': {
      padding: '12px 16px 12px 40px', // Added left padding for icon
      color: theme.palette.text.primary,
    },
    '& fieldset': {
      borderColor: 'transparent',
    },
    '&:hover fieldset': {
      borderColor: alpha(theme.palette.primary.main, 0.3),
    },
    '&.Mui-focused fieldset': {
      borderWidth: '1px',
      borderColor: alpha(theme.palette.primary.main, 0.5),
      boxShadow: `0 0 0 2px ${alpha(theme.palette.primary.main, 0.2)}`,
    },
  },
  '& .MuiInputLabel-root': {
    color: theme.palette.text.secondary,
    transform: 'translate(42px, 14px) scale(1)', // Adjusted for icon space
    '&.Mui-focused, &.MuiFormLabel-filled': {
      transform: 'translate(24px, -9px) scale(0.75)',
      color: theme.palette.primary.main,
      fontWeight: 500,
      backgroundColor: theme.palette.background.paper,
      padding: '0 4px',
      left: '-8px'
    },
  },
  '& .MuiInputAdornment-root': {
    marginRight: '0px', // Remove default margin
  }
}));

const Filters = ({ onFilterChange }) => {
  const theme = useTheme();
  const [eventName, setEventName] = useState('');

  const handleFilterChange = (event) => {
    const value = event.target.value;
    setEventName(value);
    onFilterChange(value);
  };

  const handleClear = () => {
    setEventName('');
    onFilterChange('');
  };

  return (
    <Box sx={{ 
      mb: 3,
      px: 1,
      width: '100%',
      maxWidth: 450,
      position: 'relative'
    }}>
      <SearchField
        label="Search events"
        variant="outlined"
        fullWidth
        value={eventName}
        onChange={handleFilterChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start" sx={{ position: 'absolute', left: '14px' }}>
              <SearchIcon 
                fontSize="small" 
                sx={{ 
                  color: theme.palette.mode === 'dark' 
                    ? theme.palette.text.secondary 
                    : theme.palette.primary.main 
                }} 
              />
            </InputAdornment>
          ),
          endAdornment: eventName && (
            <IconButton
              size="small"
              onClick={handleClear}
              sx={{ 
                position: 'absolute',
                right: '8px',
                color: theme.palette.text.secondary,
                '&:hover': {
                  color: theme.palette.error.main
                }
              }}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          ),
        }}
      />
    </Box>
  );
};

export default Filters;